
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { PopularExplanation, SimiliarUsersExplanation } from '../../../../ts/models/IVizRecommendationInfo';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';

export interface RecommendationProps {
  explanationType: string;
  users: IUserInfo[];
  urls: SpacesSiteUrls;
}

function generateSimiliarUserNames(users: IUserInfo[], urls: SpacesSiteUrls) {
  if (users) {
    let userName = '';
    return (
    <div className={DetailsTooltipStyles.MetadataLinksDescription}>
      {users && users.map((user: IUserInfo, i) => {
          if (users.length - 1 === i) {
            userName = user.displayName;
          } else {
            userName = user.displayName + ',';
          }
          return <span key={i} className={DetailsTooltipStyles.MetadataLinks}><a href={ urls.userContentUrl(user.username, user.domainName) }>{userName}</a></span>;
        })}
    </div>
    );
  }
}

export function Recommendation(props: RecommendationProps) {
  const {explanationType, users, urls} = props;
  let explanationMessage = '';

  if (explanationType === PopularExplanation) {
    explanationMessage = Messages.vizRecommendationsPopularExplanationLong();
  } else if (explanationType === SimiliarUsersExplanation) {
    explanationMessage = Messages.vizRecommendationsSimiliarUsersExplanationLong();
  }

  if (explanationMessage) {
    return (
      <div className={DetailsTooltipStyles.MetadataSection}>
        <div className={DetailsTooltipStyles.MetadataTitle}>{Messages.vizRecommendationsExplanationBase()}</div>
        <div className={DetailsTooltipStyles.MetadataTextDescription}>{explanationMessage}</div>
        {generateSimiliarUserNames(users, urls)}
      </div>
    );
  }

  return null;
}
